module.exports = __webpack_public_path__ + "img/img12.fd1dd18f.png";